import { Text } from 'react-native'
import { useSemanticColors, SPACING, RADIUS } from '@/lib/theme/tokens'
import { FONTS } from '@/lib/brand'
import { GlassSurface } from './GlassSurface'

/**
 * Shared primitives for long-form legal content screens (privacy, terms,
 * cancellation). Lifted out of privacy.tsx so new screens match exactly.
 */

type Colors = ReturnType<typeof useSemanticColors>

export function LegalSectionTitle({ title, colors }: { title: string; colors: Colors }) {
  return (
    <Text
      style={{
        fontSize: 12,
        color: colors.textMuted,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        fontFamily: FONTS.body,
        paddingHorizontal: SPACING.md,
        marginTop: SPACING.lg,
        marginBottom: SPACING.xs,
      }}
    >
      {title}
    </Text>
  )
}

export function LegalSectionCard({ children }: { children: React.ReactNode; colors: Colors }) {
  return (
    <GlassSurface
      tone="regular"
      radius={RADIUS.lg}
      style={{
        marginHorizontal: SPACING.md,
        marginTop: SPACING.md,
      }}
      contentStyle={{
        padding: SPACING.md,
      }}
    >
      {children}
    </GlassSurface>
  )
}

/** Standard body paragraph inside a LegalSectionCard. */
export function LegalBody({ children, colors }: { children: React.ReactNode; colors: Colors }) {
  return (
    <Text
      style={{
        fontSize: 14,
        color: colors.textPrimary,
        fontFamily: FONTS.body,
        lineHeight: 20,
      }}
    >
      {children}
    </Text>
  )
}
